<section class="py-6 border-b border-b-shs-gray-4" [formGroup]="productDamageDomesticForm!">
    <h2 class="text-base font-bold text-font-primary">Additional Information</h2>
    <div class="mt-4 flex flex-col gap-4">
        @switch (productDamageDomesticForm?.controls?.damageType?.value) { @case
        (damageTypes.CONCEALED_INTERNAL_PACKAGING) {
        <sag-ui-select
            [required]="true"
            label="Package Type containing damaged products"
            placeholder=""
            formControlName="packageType"
            class="max-w-input"
        >
            @for (packageType of packageTypes | keyvalue; track $index) {
            <sag-ui-option [value]="packageType.value">{{ packageType.value }}</sag-ui-option>
            }
        </sag-ui-select>
        <sag-ui-radio-group label="Was any Protective Packaging Used?" direction="row" [required]="true">
            <sag-ui-radio name="protectivePackagingUsed" formControlName="protectivePackagingUsed" [value]="true"
                >Yes</sag-ui-radio
            >
            <sag-ui-radio name="protectivePackagingUsed" formControlName="protectivePackagingUsed" [value]="false"
                >No</sag-ui-radio
            >
        </sag-ui-radio-group>
        <sag-ui-select
            [required]="true"
            label="Package Type Condition"
            placeholder=""
            formControlName="packageTypeCondition"
            class="max-w-input"
        >
            @for (packageTypeCondition of packageTypeConditions | keyvalue; track $index) {
            <sag-ui-option [value]="packageTypeCondition.value">{{ packageTypeCondition.value }}</sag-ui-option>
            }
        </sag-ui-select>
        <sag-ui-textarea
            [required]="true"
            label="Include any additional information regarding packaging"
            placeholder="Provide any relevant details about the issue"
            formControlName="additionalPackagingInfo"
            class="max-w-input"
        ></sag-ui-textarea>
        } @default {
        <sag-ui-radio-group
            label="Did the Delivery Documentation note the potential issue?"
            direction="row"
            [required]="true"
        >
            <sag-ui-radio name="documentationNotedIssue" formControlName="documentationNotedIssue" [value]="true"
                >Yes</sag-ui-radio
            >
            <sag-ui-radio name="documentationNotedIssue" formControlName="documentationNotedIssue" [value]="false"
                >No</sag-ui-radio
            >
        </sag-ui-radio-group>

        @if (isTrue('documentationNotedIssue')) {
        <app-attachments-input
            label="Attach a copy of the Delivery Documentation"
            [form]="productDamageDomesticForm!"
            [required]="true"
            controlName="deliveryDocumentation"
        ></app-attachments-input>
        }

        <sag-ui-radio-group label="Damage Claim filed with Carrier?" direction="row" [required]="true">
            <sag-ui-radio name="damageClaimFiled" formControlName="damageClaimFiled" [value]="true">Yes</sag-ui-radio>
            <sag-ui-radio name="damageClaimFiled" formControlName="damageClaimFiled" [value]="false">No</sag-ui-radio>
        </sag-ui-radio-group>
        } }

        <div>
            <label class="text-sm text-shs-gray-1"
                ><span>*</span>Describe the condition of the item (select all that apply)</label
            >
            <div class="flex flex-col gap-2">
                @for (condition of itemConditions | keyvalue; track $index) {
                <sag-ui-checkbox
                    [checked]="itemConditionSelected(condition.value)"
                    [disabled]="productDamageDomesticForm?.disabled ?? false"
                    (change)="toggleItemCondition(condition.value)"
                    >{{ itemConditionMapping[condition.value] }}</sag-ui-checkbox
                >
                }
            </div>
        </div>

        @if (isDefinedItemCondition()) {
        <app-attachments-input
            label="Attach visual evidence of the damage. Include image of internal and external packaging"
            [form]="productDamageDomesticForm!"
            [required]="true"
            controlName="visualEvidence"
        ></app-attachments-input>
        <sag-ui-input
            [required]="true"
            label="Related No-Charge Replacement or Credit/Debit Number"
            placeholder="Enter the credit/debit number (e.g., 3249 2341 3543 12352)"
            formControlName="creditNumber"
            class="max-w-input"
        ></sag-ui-input>
        <sag-ui-input
            [required]="true"
            label="Related Call Tag Tracking Number"
            placeholder="Enter the tracking number (e.g., 732974323)"
            formControlName="callTagTrackingNumber"
            class="max-w-input"
        ></sag-ui-input>
        <app-attachments-input
            [form]="productDamageDomesticForm!"
            controlName="relatedDocuments"
        ></app-attachments-input>
        <sag-ui-textarea
            [required]="true"
            label="Provide any additional information that will aid the Root Cause Investigation"
            placeholder="Provide any relevant details about the issue"
            formControlName="additionalInfo"
            class="max-w-input"
        />
        <sag-ui-radio-group
            label="Would the customer like a financial adjustment (credit)?"
            direction="row"
            [required]="true"
        >
            <sag-ui-radio name="financialAdjustment" formControlName="financialAdjustment" [value]="true"
                >Yes</sag-ui-radio
            >
            <sag-ui-radio name="financialAdjustment" formControlName="financialAdjustment" [value]="false"
                >No</sag-ui-radio
            >
        </sag-ui-radio-group>
        @if (isTrue('financialAdjustment')) {
        <sag-ui-radio-group
            label="Has the COD been filed within 30 days of the ship date?"
            direction="row"
            [required]="true"
        >
            <sag-ui-radio name="filedWithin30Days" formControlName="filedWithin30Days" [value]="true">Yes</sag-ui-radio>
            <sag-ui-radio name="filedWithin30Days" formControlName="filedWithin30Days" [value]="false">No</sag-ui-radio>
        </sag-ui-radio-group>
        @if (isFalse('filedWithin30Days')) {
        <div class="max-w-input">
            <app-manager-select
                [formGroup]="productDamageDomesticForm!"
                controlName="managerApprovedRequest"
            ></app-manager-select>
        </div>
        }
        <sag-ui-input
            [required]="true"
            [step]="0.01"
            label="Value of the financial adjustment in US Dollars:"
            placeholder="Enter the amount in US Dollars"
            formControlName="adjustmentAmount"
            type="number"
            class="max-w-input"
            ><span ngProjectAs="end-decorator" class="text-[#F3F3F0] pr-4 h-full flex items-center justify-center">
                $
            </span></sag-ui-input
        >
        } }
        <div class="flex justify-end max-w-input">
            <sag-ui-button [disabled]="!isValid()" (click)="handleConfirm()" size="sm">Confirm</sag-ui-button>
        </div>
    </div>
</section>
